import React from "react";
import {
  FaChevronRight,
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaMapMarkedAlt,
  FaPhoneAlt,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      {/* ================== Footer Two Start ==================*/}
      <footer className='footer-area footer-area-2 bg-gray mt-0 pd-top-120'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-4 col-md-6'>
              <div className='widget widget_about'>
                <div className='thumb'>
                  <img src="/assets/img/hna-meak/Hna_m3ak_logo.png" alt='Hna M3ak' />
                </div>
                <div className='details'>
                  <p>
                    Melbourne is simply is dumiomy is text Lorem Ipsum is simply
                  </p>
                  <div className='subscribe mt-4'>
                    <input type='text' placeholder='E-mail' />
                    <button>
                      <FaChevronRight />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 ps-xl-5'>
              <div className='widget widget_nav_menu'>
                <h4 className='widget-title'>Nos Services</h4>
                <ul>
                  <li>
                    <Link to='/'>
                      <FaChevronRight /> Acceuil
                    </Link>
                  </li>
                   <li>
                    <Link to='/service'>
                      <FaChevronRight /> Service
                    </Link>
                  </li>
                   <li>
                    <Link to='/pages'>
                      <FaChevronRight /> Pages
                    </Link>
                  </li>
                   <li>
                    <Link to='/Contactez-nous'>
                      <FaChevronRight /> Contactez-nous
                    </Link>
                  </li>

                  <li>
                    <Link to='/login'>
                      <FaChevronRight /> Connexion
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-lg-4 col-md-6'>
              <div className='widget widget-recent-post'>
                <h4 className='widget-title'>Contactez-nous</h4>
                <div className='widget widget_contact'>
                  <ul className='details'>
                    <li>
                      <FaMapMarkedAlt />
                      N°30, Avenue Oqba AGDAL -RABAT
                    </li>
                    <li className='mt-3'>
                      <FaPhoneAlt /> +212 (0) 5 37 68 18 20
                    </li>
                    <li className='mt-2'>
                      <FaEnvelope /> contact@mon-miroir.com
                    </li>
                  </ul>
                  <ul className='social-media mt-4'>
                    <li>
                      <a href='#'>
                        <FaFacebookF />
                      </a>
                    </li>
                    <li>
                      <a href='#'>
                        <FaInstagram />
                      </a>
                    </li>
                    <li>
                      <a href='#'>
                        <FaYoutube />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='footer-bottom'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-6 align-self-center'>
                <p>© Hna M3ak 2025 | All Rights Reserved</p>
              </div>
              <div className='col-md-6 text-lg-end'>
                <a href='#'>Trams &amp; Condition</a>
                <a href='#'>Privacy Policy</a>
                <a href='#'>Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* ================== Footer Two  end ==================*/}
    </>
  );
};

export default Footer;
